<template>
    <sections>
        <app-subheader :title="contextVideo.title()" :parent="contextVideo.parent()" :dark="true">
            <button-subheader
                v-if="isAdmin && video"
                buttonIcon="edit"
                buttonText="Edit"
                :buttonHref="$config.public.admin.video + video.id_video"
                :dark="true"
            ></button-subheader>
        </app-subheader>
        <section-video v-if="video" :video="video"></section-video>
        <section-text
            v-if="error"
            heading="404 Not Found"
            headingColor="text-zinc-200"
            content="<p>Apologies, but we can't find that video.</p>"
            contentColor="text-zinc-400"
        ></section-text>
        <loading-spinner v-if="video === null && !error"></loading-spinner>
    </sections>
</template>

<script setup>
const idVideo = useRoute().params.idVideo;

const {isAdmin} = storeToRefs(useStoreAuth());

const {error, video} = storeToRefs(useStoreVideo());
const {getVideo} = useStoreVideo();

await useLazyAsyncData('getVideo' + idVideo, () => getVideo(idVideo).then(() => true));

onMounted(async () => {
    if (video.value && !video.value?.id_video_play) getVideo(idVideo);
});

useSeoVideo().buildReactiveHead(video, error);

const contextVideo = useContextVideo();
</script>
